<div class="flex flex-col h-full w-full p-3 max-h-full overflow-hidden px-8">
  <div class="w-full max-w-full block lg:h-fit sm:h-[14%]">
    <app-plant-details [categoryId]="'3'"></app-plant-details>
  </div>

  <div
    class="flex flex-wrap justify-between sm:gap-3 lg:gap-1.5 sm:mt-1 lg:mt-[1%] items-center flex-grow overflow-auto w-full"
  >
 

    <div
      class="lg:w-[32.7%] lg:h-[48.5%] bg-[#252A30] sm:h-[18rem] md:h-[20rem] lg:max-h-unset flex flex-col sm:w-full rounded-2xl p-4 lg:m-[0.1%] lg:min-h-[309px]"
    >
      <div class="lg:pt-2 sm:pt-0.5">
        <span class="text-base font-medium text-white">{{
          "non_solar" | translate
        }}</span>
      </div>
      <div class="flex-1 flex flex-grow sm:justify-center">
        <div class="flex justify-center items-center h-full">
          <img
            src="../../../../../assets/svg/non-solar-home.svg"
            class="w-[70%] xl:h-[46%] lg:h-[40%] sm:h-[70%]"
            alt="Solar home"
          />
        </div>
        <div
          class="sm:flexDirCol md:mt-24 lg:mt-0 md:w-fit lg:w-unset md:flex-row lg:flex-col flex ml-14 justify-between xxl:pb-10 xxl:pt-5 lg:pt-2.5 lg:pb-7 items-start"
        >
          <div class="flex flex-col md:ml-5 lg:ml-0">
            <div>
              <span class="lg:text-base text-dark-gray-content"
                >Home Consumption</span
              >
            </div>
            <div class="xxl:mt-2 lg:mt-1.5 sm:mt-1.5">
              <span class="text-white xxl:text-lg lg:text-base">
                {{ powerCutDetailsAndSummary.backupCapacityPercentage ?? "0" }}
                %</span
              >
            </div>
          </div>
          <div class="flex flex-col sm:mt-2.5 md:mt-0 md:ml-8 lg:ml-0">
            <div>
              <span class="lg:text-base text-dark-gray-content"
                >Total Backup Capacity</span
              >
            </div>
            <div class="xxl:mt-2 lg:mt-1.5 sm:mt-1.5">
              <span class="text-white lg:text-base">
                {{
                  powerCutDetailsAndSummary.totalBackupCapacity ?? "NA"
                }}</span
              >
            </div>
          </div>
          <div
            class="flex flex-col sm:pb-9 lg:pb-0 sm:mt-2.5 md:mt-0 md:ml-10 lg:ml-0"
          >
            <div>
              <span class="lg:text-base text-dark-gray-content"
                >Current Backup Capacity</span
              >
            </div>
            <div class="lg:mt-1.5 xxl:mt-2 sm:mt-1.5">
              <span class="text-white xxl:text-lg lg:text-base">
                {{
                  powerCutDetailsAndSummary.currentBackupCapacity ?? "NA"
                }}</span
              >
            </div>
          </div>
        </div>
      </div>
    </div>
   
    <div
      class="lg:w-[32.7%] lg:h-[48.5%] lg:m-[0.1%] lg:min-h-[309px] sm:h-[19rem] sm:w-full flex bg-[#252A30] md:flex-row sm:flex-col items-center text-white rounded-2xl p-4"
    >
      <div class="w-full h-full">
        <app-powercut-and-summary [categoryId]="'3'"></app-powercut-and-summary>
      </div>
    </div>

 
    <div
      class="lg:w-[32.7%] lg:h-[48.5%] bg-[#252A30] sm:h-[18.2rem] flex flex-col sm:w-full rounded-2xl p-4 lg:m-[0.1%] lg:min-h-[309px] sm:max-h-fit md:h-[21rem] md:max-h-fit"
    >
      <div class="lg:pt-2 sm:pt-0.5">
        <span class="text-base font-medium text-white">{{
          "plant_health" | translate
        }}</span>
      </div>
      <div
        class="h-full flex sm:flex-grow lg:flex-grow items-center justify-center"
      >
        <div
          class="sm:w-10/12 md:w-8/12 lg:w-11/12 xxl:w-10/12 h-full flex items-center"
        >
          <div
            class="flex flex-col justify-center sm:w-[40%] md:w-[30%] lg:w-[40%] items-center text-white"
          >
            <app-radial-bar
              [dataLabel]="'Healthy'"
              [dataSeries]="nonSolarPlant.healthyPlantPercent"
              [maxSize]="155"
            ></app-radial-bar>
          </div>
          <div
            class="flexDirCol sm:ml-8 lg:ml-4 sm:gap-10 lg:gap-7 xxl:gap-10 sm:flex-grow lg:flex-grow"
          >
            <div
              class="flex sm:justify-between lg:justify-between sm:w-[78%] md:w-[66%] lg:w-full"
            >
              <div>
                <span class="text-base text-dark-gray-content"
                  >Total Plants
                </span>
              </div>

              <div>
                <span class="text-white text-lg text-end">
                  {{ nonSolarPlant.totalPlant }}</span
                >
              </div>
            </div>

            <div
              class="flex sm:justify-between lg:justify-between sm:w-[78%] md:w-[66%] lg:w-full"
            >
              <div>
                <span class="text-base text-dark-gray-content">
                  Healthy Plants</span
                >
              </div>

              <div>
                <span class="text-lg text-white">
                  {{ nonSolarPlant.healthyPlant }}</span
                >
              </div>
            </div>

            <div
              class="flex sm:justify-between lg:justify-between sm:w-[78%] md:w-[66%] lg:w-full"
            >
              <div>
                <span class="text-base text-dark-gray-content"
                  >Unhealthy Plants</span
                >
              </div>

              <div>
                <span class="text-lg text-white">
                  {{ nonSolarPlant.unhealthyPlant }}</span
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

   

    <div
      class="lg:w-[66.2%] lg:h-[48.5%] lg:m-[0.1%] lg:min-h-[309px] sm:w-full bg-[#252A30] items-center rounded-2xl p-4 sm:h-[22rem] sm:max-h-fit md:max-h-fit"
    >
      <app-trends [categoryId]="'2'"></app-trends>
    </div>
   
    <div
      class="lg:w-[32.7%] lg:h-[48.5%] bg-[#252A30] sm:w-full lg:m-[0.1%] lg:min-h-[309px] items-center rounded-2xl p-4 sm:h-[17rem] sm:max-h-fit md:h-[21rem] md:max-h-fit"
    >
      <app-today-alerts [categoryId]="'3'"></app-today-alerts>
    </div>
  </div>
</div>
